import * as React from 'react';
import PropTypes from 'prop-types';
import { Button, Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeRedirectUrl } from '../../redux/global/redirect/selector';
import { push } from 'connected-react-router/immutable';
import { compose } from 'redux';
import { changeRedirectState } from '../../redux/global/redirect/actions';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

export class NavBarButtonMenu extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const navbarButton = this.props.buttonList.map(data => {
      const content = data.translate ? (
        <FormattedMessage {...messages[data.content]} />
      ) : (
        data.content
      );
      return (
        <Menu.Item
          key={data.key}
          onClick={() => this.props.handleItemClick(data.href, data.redirect)}
        >
          <Button id={'loginButton'}>{content}</Button>
        </Menu.Item>
      );
    });
    return <React.Fragment>{navbarButton}</React.Fragment>;
  }
}

NavBarButtonMenu.propTypes = {
  buttonList: PropTypes.array.isRequired,
  handleItemClick: PropTypes.func,
  navbarTransparent: PropTypes.bool
};

export function mapDispatchToProps(dispatch) {
  return {
    handleItemClick: (href, redirect) => {
      if (redirect) {
        dispatch(changeRedirectState(redirect));
      }
      dispatch(push(href));
      window.scrollTo(0, 0);
    }
  };
}

const mapStateToProps = createStructuredSelector({
  redirectState: makeRedirectUrl()
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(withConnect)(NavBarButtonMenu);



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBarButtonMenu.js